import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import nullToEmpty from "utils/nullToEmpty";
import { toast } from 'react-toastify';
import validate from "utils/validate";
import Maybe from "components/__new/common/Maybe";
import { BackButtonPage } from "components/__new/common/BackButton";
import TabSettings from "components/__new/common/TabSettings";
// import { Checkbox, Input } from "components/__new/common/form";
import { Input } from "components/__new/common/form";
import useLoginInfo from "hooks/useLoginInfo";
import Table from "components/__new/common/Table";
import { TableContent } from "components/__new/common/TableContent";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import * as auth from "store/auth/user/action";
import * as adminActions from "store/entities/settingsAdmin/action";
import Pagination from "components/__new/common/pagination";


const AddSubAccountAdminInfo = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { subAccountForm } = useSelector((s) => s.auth.user);

    
    const [newSubAccountAdmin, setNewSubAccountAdmin] = useState(subAccountForm?.newUser);
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        jobTitle: "",
        phoneNumber: "",
        email: "",
    })


    const updateForm = (newUser) => {
        let user = {};
        if (userInfo.employer.accountType === "sub"){
            user = userInfo?.mainAccount;
        }
        else{
            user = userInfo;
        }

        if (newUser === false){
            const params = {
                firstName: user?.employer?.firstName,
                lastName: user?.employer?.lastName,
                email: user?.employer?.email,
                phoneNumber: user?.employer?.phoneNumber,
                jobTitle: user?.employer?.jobTitle,
            }
            setForm(params);
        }
        else{
            const params = {
                firstName: nullToEmpty(subAccountForm.firstName),
                lastName: nullToEmpty(subAccountForm.lastName),
                email: nullToEmpty(subAccountForm.email),
                phoneNumber: nullToEmpty(subAccountForm.phoneNumber),
                jobTitle: nullToEmpty(subAccountForm.jobTitle),
            }
            setForm(params);
        }
    }


    const setFormAsReadOnly = () => {
        if (newSubAccountAdmin === false){
            return true;
        }
        return false;
    }


    const selectAdmin = (admin) => {
        setForm({
            firstName: admin?.firstName,
            lastName: admin?.lastName,
            jobTitle: admin?.jobTitle,
            phoneNumber: admin?.phoneNumber,
            email: admin?.email,
        })
    }


    const submitForm = async e => {
        e.preventDefault();
        
        const trimmedForm = {
            firstName: form?.firstName?.trim(),
            lastName: form?.lastName?.trim(),
            email: form?.email?.trim(),
            phoneNumber: form?.phoneNumber?.trim(),
            jobTitle: form?.jobTitle?.trim(),
        }

        const errors = validate(trimmedForm);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return false;
        }
        else{
            let params = {
                ...subAccountForm,
                ...trimmedForm,
                // newUser: newSubAccountAdmin,
                newUser: false,
            };
            dispatch(auth.saveSubAccountForm(params));
            history.push("/account/add/preview");
        }
    }


    useEffect(() => {
        if (userInfo?.employer?.accountType === "sub" && Object.keys(userInfo?.mainAccount).length === 0){
            history.replace("/401");
        }
        
        if ("sameCompany" in subAccountForm){
            updateForm(subAccountForm.newUser);
            setNewSubAccountAdmin(true);
        }
        else{
            history.push("/account/add");
        }
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        updateForm(newSubAccountAdmin);
        // eslint-disable-next-line
    }, [newSubAccountAdmin])


    return (
        <div>

            <DynamicHeadTag
                headerText="Admin Details | Sub Accounts"
                headerDescription={null}
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <BackButtonPage />
                        Add Business
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 box">
                <div className="border-b">
                    <TabSettings options={[
                        {
                            title: <span>[1] Business Details</span>,
                            type: "link",
                            url: "/account/add/company",
                        },
                        {
                            title: <span>[2] Admin Details</span>,
                            type: "div",
                            isActive: true,
                        },
                        {
                            title: <span>[3] Preview Details</span>,
                            type: "div",
                        },
                    ]} />
                </div>
                

                <div className="mt-6">

                    <form onSubmit={submitForm}>

                        <div>
                            Almost done, one more step to completion.
                        </div>

                        {/* 
                        <div className="mt-6 flex flex-wrap">
                            <div className="mr-14 mb-2">
                                <Checkbox
                                    type="radio"
                                    label="Use existing admin details"
                                    checked={newSubAccountAdmin === false}
                                    onChange={(e) => setNewSubAccountAdmin(false)}
                                />
                            </div>
                            <div>
                                <Checkbox
                                    type="radio"
                                    label="Invite new admin"
                                    checked={newSubAccountAdmin === true}
                                    onChange={(e) => setNewSubAccountAdmin(true)}
                                />
                            </div>
                        </div>
                         */}
                        
                        
                        <div className="mt-12 flex flex-col xl:flex-row xl:justify-between">
                            <div className="w-full xl:w-1/2 xl:flex-shrink-0 mt-12 xl:mt-0 xl:pr-8 order-2 xl:order-1">
                                <div className="font-medium">
                                    Invite new admin
                                </div>

                                <div className="mt-3 p-6 bg-[#F6F6F6] border border-gray-200 rounded-lg">
                                    <Maybe condition={newSubAccountAdmin === true || newSubAccountAdmin === false}>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">

                                            <Input type="text" label="First Name" placeholder="Enter the first name" value={form.firstName} onChange={(e) => setForm({...form, firstName: e.target.value})} disabled={setFormAsReadOnly()} inputClass="capitalize" />
                                            
                                            <Input type="text" label="Last Name" placeholder="Enter the last name" value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} disabled={setFormAsReadOnly()} inputClass="capitalize" />
                                            
                                            <Input type="text" label="Job Title" placeholder="Enter the job title" value={form.jobTitle} onChange={(e) => setForm({...form, jobTitle: e.target.value})} disabled={setFormAsReadOnly()} />
                                            
                                            <Input type="tel" label="Phone Number" placeholder="E.g: 08030102000" value={form.phoneNumber} onChange={(e) => setForm({...form, phoneNumber: e.target.value})} disabled={setFormAsReadOnly()} />
                                            
                                            <Input type="email" label="Email Address" placeholder="E.g: example@email.com" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} disabled={setFormAsReadOnly()} />
                                            <Maybe condition={subAccountForm.newUser === true}>
                                                <div className="text-xs">
                                                    This is the address that gets the invite and receives mail notifications
                                                </div>
                                            </Maybe>

                                        </div>
                                    </Maybe>
                                    <Maybe condition={newSubAccountAdmin !== true && newSubAccountAdmin !== false}>
                                        <div className="mt-10"></div>
                                    </Maybe>

                                    <div className="mt-6 flex justify-start space-x-4">
                                        <button type="submit" className="btn btn-ep-primary" disabled={newSubAccountAdmin !== true && newSubAccountAdmin !== false}>
                                            Continue
                                        </button>
                                        <button type="button" onClick={() => history.goBack()} className="btn btn-transparent-primary">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            
                            <div className="w-full xl:w-1/2 xl:flex-shrink-0 xl:pl-8 order-1 xl:order-2">
                                <AdminSelection
                                    selectAdmin={selectAdmin}
                                />
                            </div>
                        </div>

                    </form>

                </div>
            </div>


        </div>
    )
}


const AdminSelection = (props) => {
    const { selectAdmin } = props;
    const location = useLocation();
    const dispatch = useDispatch();
    const {urlQueryParams} = useUrlQueryParams();
    const { loading: adminsLoading, allAdmin: admins } = useSelector((s) => s.entities.settingsAdmin);
    
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });

    const getAdmins = () => {
        let params = {...listParams};
        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        setListParams(params);
        dispatch(adminActions.getAllAdmin(params));
    }
    
    useEffect(() => {
        getAdmins();
        // eslint-disable-next-line
    }, [location]);
    
    return (
        <div>
            <div className="font-medium">
                Select an existing admin
            </div>
            <div className="w-full mt-3 border border-gray-200 rounded-lg">
                <Table>
                    <Table.Head>
                        <th>Full Name</th>
                        <th>Email Address</th>
                        <th>Phone Number</th>
                        <th>Job Title</th>
                        <th>Status</th>
                    </Table.Head>
                    <Table.Body>
                        <TableContent
                            loading={adminsLoading}
                            loadingText="Loading administrators"
                            data={admins?.docs}
                            colspan={5}
                        />

                        {adminsLoading === false && admins?.docs?.map((admin, index) =>
                            <tr key={index} onClick={() => selectAdmin(admin)} className="hover:bg-gray-200 cursor-pointer">
                                <td>
                                    <div className="font-medium capitalize">
                                        {admin.firstName} {admin.lastName}
                                    </div>
                                </td>
                                <td>
                                    {admin.email}
                                </td>
                                <td>
                                    {admin.phoneNumber}
                                </td>
                                <td>
                                    {admin.jobTitle}
                                </td>
                                <td>
                                    {(admin.disabled === true) &&
                                        <div className="label label-red">
                                            Inactive
                                        </div>
                                    }
                                    {(admin.disabled === false) &&
                                        <div className="label label-green">
                                            Active
                                        </div>
                                    }
                                </td>
                            </tr>
                        )}
                    </Table.Body>
                </Table>
                
                <Maybe condition={adminsLoading === false && admins?.docs?.length > 0}>
                    <div className="mt-6">
                        <Pagination data={admins} />
                    </div>
                </Maybe>
            </div>
        </div>
    )
}


export default AddSubAccountAdminInfo;